import { parseHttpError } from '@upme/api-client';
import { Button } from '@upme/ui/components/button';
import { Input } from '@upme/ui/components/input';
import { Label } from '@upme/ui/components/label';
import { type FormEvent, useState } from 'react';
import { toast } from 'sonner';
import { useBlockOrganizer } from '../mutations';

const SERVER_ERRORS: Record<string, string> = {
  organizer_already_blocked: 'Этот организатор уже заблокирован',
};

/** Блокировка организатора по нику с обязательной причиной (#190). */
export function BlockOrganizerForm() {
  const [username, setUsername] = useState('');
  const [reason, setReason] = useState('');
  const [error, setError] = useState<string | null>(null);
  const block = useBlockOrganizer();

  const canSubmit = username.trim().length > 0 && reason.trim().length > 0 && !block.isPending;

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      const row = await block.mutateAsync({ username, reason });
      toast.success(`@${row.username} заблокирован`);
      setUsername('');
      setReason('');
    } catch (err) {
      const apiErr = await parseHttpError(err);
      if (apiErr?.status === 400) setError('Проверьте ник: 5–32 символа, латиница, цифры и «_»');
      else
        setError((apiErr && SERVER_ERRORS[apiErr.message]) ?? apiErr?.message ?? 'Не удалось заблокировать');
    }
  };

  return (
    <form onSubmit={onSubmit} className="space-y-3 rounded-lg border p-4">
      <div>
        <Label htmlFor="block-username">Ник организатора в Telegram</Label>
        <Input
          id="block-username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="@nickname"
          autoComplete="off"
        />
      </div>
      <div>
        <Label htmlFor="block-reason">Причина</Label>
        <textarea
          id="block-reason"
          rows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Например: блокирует гостей, которые пишут через UpMe"
          className="flex w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring"
        />
      </div>
      {error ? <p className="text-sm text-destructive">{error}</p> : null}
      <Button type="submit" variant="destructive" disabled={!canSubmit}>
        Заблокировать
      </Button>
    </form>
  );
}
